const roundMinutes = (date) => {
    date.setHours(date.getHours() + Math.round(date.getMinutes() / 60));
    date.setMinutes(0, 0, 0); // Resets also seconds and milliseconds
    return date;
};
export const actions = {
    setStartDate({ state }, date) {
        state.startDate = roundMinutes(date);
    },
    open({ state }) {
        state.active = true;
    },
    toggle({ state }) {
        state.active = !state.active;
    },
    close({ state }) {
        state.active = false;
    },
};
